/**
 * Serializes a value for embedding inside a `<script type="application/ld+json">` element.
 *
 * `JSON.stringify` leaves angle brackets intact, so any string in the graph that came from
 * user input can close the script element early and have the rest of its content parsed as
 * live HTML. Escaping `<` and `>` as JSON unicode escapes keeps the HTML tokenizer in
 * script-data state; consumers still see the original characters after `JSON.parse`, so
 * search-engine parsing of the structured data is unaffected.
 *
 * Always use this instead of `JSON.stringify` when building a JSON-LD block.
 */
export function stringifyJsonLd(value: unknown): string {
  // String() keeps the previous template-literal behaviour for values JSON.stringify drops.
  return String(JSON.stringify(value)).replace(/</g, '\\u003c').replace(/>/g, '\\u003e');
}

export function clearEmptyFields(obj: $TSFixMe) {
  const currObj = Object.assign({}, obj);
  const keys = Object.keys(currObj);

  keys.forEach((k) => {
    if (!currObj[k]) {
      delete currObj[k];
    }
  });

  return currObj;
}
